<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeFactures.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeFactures.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div
      class="column is-12 overflow-auto
      is-marginless"
      :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="column is-12 pdb-0">
        <qd-notification type="is-primary" v-if="tiers" class="is-marginless pd-6px"
                        @close="deleteTiersId()">
          {{ $t('listeFactures.filtre.tiers', { client: tiers.nomCommercial }) }}
        </qd-notification>
      </div>
      <div class="column is-12 pdb-0">
        <qd-notification type="is-primary" v-if="commandes.length > 0" class="is-marginless pd-6px"
                        @close="deleteReferenceIdsOrCommandeId()">
          {{ $t('listeFactures.filtre.referencesCommande', { code: getCodeCommande }) }}
        </qd-notification>
      </div>
      <div class="columns is-marginless is-multiline">
        <div v-if="modulePlanMediaActive" class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.planMedia')">
            <qd-taginput
              v-model="planMediaSelected"
              :data="filteredPlanMedia"
              :loading="isFetchingPlanMedia"
              icon="magnify"
              type="is-primary"
              field="code"
              autocomplete
              @typing="getfilteredPlanMedia">
              <template slot-scope="props">
                {{ props.option.code }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingPlanMedia">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.commande')">
            <qd-taginput
              v-model="commandeSelected"
              :data="filteredCommande"
              :loading="isFetchingCommande"
              icon="magnify"
              type="is-primary"
              field="code"
              autocomplete
              @typing="getfilteredCommande">
              <template slot-scope="props">
                {{ props.option.code }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingCommande">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div v-if="modulePresseActive" class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.regleFacturation')">
            <qd-taginput
              v-if="regleFacturationTags"
              v-model="regleFacturationSelected"
              :data="regleFacturationTags"
              type="is-primary"
              icon="magnify"
              field="libelle"
              autocomplete
              open-on-focus
              @typing="getFilteredRegleFacturationTags"
              @input="getRegleFacturationTag">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <query-client-tag-input
            v-model="clientsSelected"
            :societeActiveId="societeActiveId"
            :label="$t('listeFactures.filtre.client')"
            :disabled="isListeFacturesClient">
          </query-client-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.referenceClient')">
            <b-input v-model="critereRecherche.referenceClient ">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.codeDossier')">
            <b-input v-model="critereRecherche.codeDossier ">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.interne')">
            <b-select v-model="critereRecherche.interne">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false">
                {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div v-if="factureParEmail" class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.factureParEmail')">
            <b-select v-model="critereRecherche.factureParEmail">
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.nePasRelancer')">
            <b-select v-model="critereRecherche.nePasRelancer">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false">
                {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.theme')">
            <qd-taginput v-model="critereRecherche.themes"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <libelle-tag-input
                      :label="$t('listeFactures.filtre.etat')"
                      :items="constantes.FACTURE_ETAT"
                      v-model="critereRecherche.etat">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                        :label="$t('listeFactures.filtre.type')"
                        :items="constantes.FACTURE_SOUS_TYPE"
                        v-model="critereRecherche.type">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('listeFactures.filtre.commercial')"
                        :blocked="userIsCommercialBlocked"
                        v-model="commercialSelected"
                        :items="listeCommercial">
        </user-tag-input>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('listeFactures.filtre.assistant')"
                        v-model="assistantSelected"
                        :items="listeAssistant">
          </user-tag-input>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.dates"
            :label="$t('listeFactures.filtre.periode')">
          </input-periode>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.datesPremierAffichage"
            :label="$t('listeFactures.filtre.datePremierAffichage')">
          </input-periode>
        </div>
        <div class="column is-12 is-marginless">
          <input-montant
            v-model="critereRecherche.montantHt"
            :label="$t('listeFactures.filtre.montantHt')">
          </input-montant>
        </div>
        <div class="column is-12 is-marginless">
          <input-montant
            v-model="critereRecherche.montantTtc"
            :label="$t('listeFactures.filtre.montantTtc')">
          </input-montant>
        </div>
        <div class="column is-12 is-marginless">
          <b-field :label="$t('listeFactures.filtre.exporteeEnCompta')">
            <b-select v-model="critereRecherche.exporteeEnCompta" expanded>
              <option :value=null></option>
              <option :value=true>{{$t('listeFactures.filtre.exporteeEnComptaAnswer.yes')}}</option>
              <option :value=false>{{$t('listeFactures.filtre.exporteeEnComptaAnswer.no')}}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.modeReglement')">
            <qd-taginput v-if="modeReglementTags"
                        v-model="modeReglementSelected"
                        :data="modeReglementTags"
                        type="is-primary"
                        icon="magnify"
                        autocomplete
                        open-on-focus
                        field="libelle"
                        @typing="getFilteredModeReglementTags"
                        @input="getModeReglementTag">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0"  v-if="isPageTransmission">
          <query-fournisseur-tag-input
            v-model="tiersFactorsSelected"
            :societeActiveId="societeActiveId"
            :label="$t('transmission.filtre.factor')"
            :sousType="[constantes.TIERS_SOUS_TYPE_FACTOR]">
          </query-fournisseur-tag-input>
        </div>
        <div class="column is-12 pdb-0"  v-if="isPageTransmission">
          <b-field :label="$t('transmission.filtre.nonFactorisable')">
            <b-select v-model="critereRecherche.nonFactorisable">
              <option :value="null"></option>
              <option :value="true">
                {{ $t('general.oui') }}
              </option>
              <option :value="false">
                {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0"  v-if="isPageTransmission">
          <b-field :label="$t('transmission.filtre.sansTiersFactorId')">
            <b-select v-model="critereRecherche.sansTiersFactorId">
              <option :value="null"></option>
              <option :value="true">
                {{ $t('general.oui') }}
              </option>
              <option :value="false">
                {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0"  v-if="isPageTransmission">
          <b-field :label="$t('transmission.filtre.factorTransmis')">
            <b-select v-model="critereRecherche.factorTransmis">
              <option :value="null"></option>
              <option :value="true">
                {{ $t('general.oui') }}
              </option>
              <option :value="false">
                {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0" v-if="isPageTransmission">
          <input-periode
            v-model="critereRecherche.factorDateTransmission"
            :label="$t('transmission.filtre.factorDateTransmission')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.produits')">
            <qd-taginput
              v-model="produitsSelected"
              icon="magnify"
              :data="filteredProduits"
              autocomplete
              type="is-primary"
              :loading="isFetchingProduits"
              field="reference"
              @typing="getfilteredProduits">
              <template slot-scope="props">
                {{ props.option.reference }} - {{ props.option.libelle }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingProduits">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div v-if="modulePresseActive" class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.parutions')">
            <qd-taginput
              v-model="parutionsSelected"
              :data="filteredParutions"
              :loading="isFetchingParutions"
              :disabled="disabledFilterParution"
              icon="magnify"
              type="is-primary"
              field="code"
              autocomplete
              @typing="getfilteredParutions">
              <template slot-scope="props">
                {{ `${props.option.code} - ${props.option.nomParution}` }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingParutions">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('listeFactures.filtre.typeProduit')"
                      :items="categorieProduit"
                      v-model="critereRecherche.categorieVente">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('listeFactures.filtre.groupe')"
            dropdown="top"
            v-model="groupeSelected"
            :typologie="this.constantes.TYPOLOGIE_GROUPE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('listeFactures.filtre.enseigne')"
            dropdown="top"
            v-model="enseigneSelected"
            :typologie="this.constantes.TYPOLOGIE_ENSEIGNE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <agence-tag-input
                      :label="$t('listeFactures.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="critereRecherche.agencesId">
          </agence-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tag-input :label="$t('listeFactures.filtre.tags')"
            v-model="critereRecherche.tagIds"
            open-on-focus
            :query="(search) => getAllTags({
              query:
              {
                auto: search,
                actif: true,
                moduleTag: constantes.DOCUMENT_VENTE,
              },
            })">
            <template slot-scope="props">
              {{ props.option.libelle }}
            </template>
          </query-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeDevis.filtre.departementPayeur')">
            <qd-taginput v-model="critereRecherche.departements" type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0" v-if="moduleSecteurActive">
          <secteur-tag-input v-model="secteursSelected"
            :label="$t('listeFactures.filtre.secteur')"
            :critere="(el) => el.type === constantes.COMMERCIAL"
            :disabled="secteurCurrentUser.length > 0">
          </secteur-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('listeFactures.filtre.actions.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('listeFactures.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { FACTURE_ETAT, FACTURE_SOUS_TYPE } from '@/configuration/facture/factureConf';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { getAll as getAllProduits } from '@/api/produit/index';
import { getAll as getAllParutions } from '@/api/presse/parution';
import { get as getTiers } from '@/api/tiers/index';
import { getAll as getAllPlanMedia } from '@/api/planMedia';
import { get, getAll as getAllCommande } from '@/api/commande';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL, ASSISTANT_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import {
  TYPOLOGIE_ENSEIGNE,
  TYPOLOGIE_GROUPE,
  TIERS_SOUS_TYPE_FACTOR,
  FACTURE_CLIENT_STORE_NAME,
} from '@/configuration/tiers/tiersConf';
import queryClientTagInput from '@/components/general/tagInput/queryClientTagInput';
import { SENS_VENTE } from '@/configuration/devisConf';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import queryTiersTagInput from '@/components/general/tagInput/queryTiersTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import userTagInput from '@/components/general/tagInput/userTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';
import queryFournisseurTagInput from '@/components/general/tagInput/queryFournisseurTagInput';
import { SET_CRITERE, RESET_CRITERE } from '@/store/mutation-type';
import inputPeriode from '@/components/general/inputPeriode';
import inputMontant from '@/components/general/inputMontant';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import secteurTagInput from '@/components/commun/secteur/secteurTagInput';
import { COMMERCIAL as SECTEURCOMMERCIAL } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import { getAll as getAllTags } from '@/api/tag/index';
import { DOCUMENT_VENTE } from '@/configuration/parametrage/tagConf';
import { isMontantValid } from '@/services/facture/validation/validationMontantService';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  props: {
    isPageTransmission: {
      type: Boolean,
      required: false,
      default: false,
    },
    factureParEmail: {
      type: Boolean,
      required: false,
    },
    storeName: {
      type: String,
      required: true,
    },
  },
  components: {
    userTagInput,
    libelleTagInput,
    queryTiersTagInput,
    agenceTagInput,
    errorMsgComponent,
    queryClientTagInput,
    queryFournisseurTagInput,
    inputPeriode,
    inputMontant,
    secteurTagInput,
    queryTagInput,
  },
  data() {
    return {
      critereRecherche: null,
      commercialSelected: [],
      listeCommercial: [],
      constantes: {
        FACTURE_ETAT,
        FACTURE_SOUS_TYPE,
        TYPOLOGIE_ENSEIGNE,
        TYPOLOGIE_GROUPE,
        TIERS_SOUS_TYPE_FACTOR,
        COMMERCIAL: SECTEURCOMMERCIAL,
        DOCUMENT_VENTE,
      },
      errors: [],
      tiers: null,
      commandes: [],
      listeModeReglementBase: [],
      modeReglementSelected: [],
      modeReglementTags: null,
      listeAssistant: [],
      assistantSelected: [],
      groupeSelected: [],
      enseigneSelected: [],
      clientsSelected: [],
      produitsSelected: [],
      isFetchingProduits: false,
      filteredProduits: [],
      parutionsSelected: [],
      isFetchingParutions: false,
      filteredParutions: [],
      planMediaSelected: [],
      isFetchingPlanMedia: false,
      filteredPlanMedia: [],
      commandeSelected: [],
      isFetchingCommande: false,
      filteredCommande: [],
      regleFacturationSelected: [],
      regleFacturationTags: null,
      tiersFactorsSelected: [],
      filteredDepartements: [],
      isFetchingDepartements: false,
      secteursSelected: [],
      secteurCurrentUser: [],
      getAllTags,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduit',
    }),
    disabledFilterParution() {
      return !!this.$route.params.parutionId;
    },
    modesReglement() {
      return this.parametre(PARAMETRES_KEYS.modeReglement);
    },
    getCodeCommande() {
      return this.commandes.map(commande => commande.code).join(', ');
    },
    blocageFiltreCommercial() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercial() {
      return this.user.profil === COMMERCIAL;
    },
    userIsCommercialBlocked() {
      return (this.userIsCommercial && this.blocageFiltreCommercial);
    },
    userIsAssistant() {
      return (this.user.profil === ASSISTANT_COMMERCIAL);
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    reglesFacturation() {
      return this.parametre(PARAMETRES_KEYS.regleFacturation)
        .filter(regle => regle.societeId === this.societeActiveId);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    secteurs() {
      return this.parametre(PARAMETRES_KEYS.secteur);
    },
    isListeFacturesClient() {
      return this.storeName === FACTURE_CLIENT_STORE_NAME;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    setCritere(critere) {
      return this.$store.commit(`${this.storeName}/${SET_CRITERE}`, critere);
    },
    resetCritere() {
      this.$store.commit(`${this.storeName}/${RESET_CRITERE}`);
    },
    getfilteredProduits: debounce(async function getProduits(search) {
      this.filteredProduits = [];
      if (!search) return;
      this.isFetchingProduits = true;
      try {
        const produits = (await getAllProduits(
          {
            query: {
              auto: search,
            },
          },
        )).data.result.items;
        this.filteredProduits = produits.filter((produit) => {
          return !this.produitsSelected.map(
            produitSelected => produitSelected.id,
          ).includes(produit.id);
        });
        this.isFetchingProduits = false;
      } catch (e) {
        this.isFetchingProduits = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getfilteredParutions: debounce(async function getParutions(search) {
      this.filteredParutions = [];
      if (!search) return;
      this.isFetchingParutions = true;
      try {
        const parutions = (await getAllParutions({
          query: {
            auto: search,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        this.filteredParutions = parutions.filter((el) => {
          return !this.parutionsSelected.map(p => p.id).includes(el.id);
        });
        this.isFetchingParutions = false;
      } catch (e) {
        this.isFetchingParutions = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getfilteredPlanMedia: debounce(async function getPlanMedia(search) {
      this.filteredPlanMedia = [];
      if (!search) return;
      this.isFetchingPlanMedia = true;
      try {
        const planMedia = (await getAllPlanMedia({
          query: {
            code: search,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        this.filteredPlanMedia = planMedia.filter((el) => {
          return !this.planMediaSelected.map(p => p.id).includes(el.id);
        });
        this.isFetchingPlanMedia = false;
      } catch (e) {
        this.isFetchingPlanMedia = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getfilteredCommande: debounce(async function getCommande(search) {
      this.filteredCommande = [];
      if (!search) return;
      this.isFetchingCommande = true;
      try {
        const commande = (await getAllCommande({
          query: {
            code: search,
            societeId: this.societeActiveId,
            sens: SENS_VENTE,
          },
        })).data.result.items;
        this.filteredCommande = commande.filter((el) => {
          return !this.commandeSelected.map(p => p.id).includes(el.id);
        });
        this.isFetchingCommande = false;
      } catch (e) {
        this.isFetchingCommande = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    deleteTiersId() {
      this.critereRecherche.tiersId = [];
      this.tiers = null;
    },
    deleteReferenceIdsOrCommandeId() {
      this.critereRecherche.commandeId = '';
      this.critereRecherche.referenceIds = [];
      this.commandes = [];
    },
    async viderCritere() {
      this.resetCritere();
      this.critereRecherche = cloneDeep(this.$store.getters[`${this.storeName}/criteresRecherche`]);
      await updateCritereWithParametreInterne(this.critereRecherche);
      this.tiers = null;
      this.commandes = [];
      this.commercialSelected = this.critereRecherche.commercialId.map(id => {
        return this.listeCommercial.find(c => c.id === id) ?? {};
      });
      this.assistantSelected = this.critereRecherche.assistantIds.map(id => {
        return this.listeAssistant.find(c => c.id === id) ?? {};
      });
      this.groupeSelected = [];
      this.enseigneSelected = [];
      this.modeReglementSelected = [];
      if (this.isListeFacturesClient
        && this.critereRecherche.clients.length > 0) {
        this.clientsSelected = this.critereRecherche.clients;
      } else this.clientsSelected = [];
      this.produitsSelected = [];
      this.parutionsSelected = [];
      this.planMediaSelected = [];
      this.commandeSelected = [];
      this.regleFacturationSelected = [];
      this.tiersFactorsSelected = [];
      if (this.moduleSecteurActive) {
        this.secteursSelected = this.secteurCurrentUser ?? [];
      }
      this.getModeReglementTag();
      this.setCritere(this.critereRecherche);
      this.$emit('recherche');
    },
    appliquerCritere() {
      this.errors = [];
      this.critereRecherche.modesReglementsIds = this.modeReglementSelected.map((modeReglement) => {
        return modeReglement.id;
      });
      if (this.critereRecherche.dates.dateFin
        && this.critereRecherche.dates.dateDebut > this.critereRecherche.dates.dateFin) {
        this.errors.push({
          message: 'listeFactures.filtre.error.errorDateFacture',
        });
      }
      if (this.critereRecherche.datesPremierAffichage.dateFin
        && this.critereRecherche.datesPremierAffichage.dateDebut
        > this.critereRecherche.datesPremierAffichage.dateFin) {
        this.errors.push({
          message: 'listeFactures.filtre.error.errorDatePremierAffichage',
        });
      }
      if (!isMontantValid(this.critereRecherche.montantHt)) {
        this.errors.push({
          message: 'listeFactures.filtre.error.errorMontantHt',
        });
      }
      if (!isMontantValid(this.critereRecherche.montantTtc)) {
        this.errors.push({
          message: 'listeFactures.filtre.error.errorMontantTtc',
        });
      }
      if (this.errors.length > 0) return;
      if (this.commercialSelected) {
        this.critereRecherche.commercialId = this.commercialSelected.map((c) => {
          return c.id;
        });
      }
      this.critereRecherche.assistantIds = this.assistantSelected.map((a) => {
        return a.id;
      });
      this.critereRecherche.groupeIds = this.groupeSelected;
      this.critereRecherche.enseigneIds = this.enseigneSelected;
      this.critereRecherche.clients = this.clientsSelected;
      this.critereRecherche.produitsIds = this.produitsSelected;
      this.critereRecherche.commandeIds = this.commandeSelected;
      if (this.modulePresseActive) {
        this.critereRecherche.parutionsIds = this.parutionsSelected;
        this.critereRecherche.regleFacturationIds = this.regleFacturationSelected;
      }
      if (this.modulePlanMediaActive) {
        this.critereRecherche.planMediaIds = this.planMediaSelected;
      }
      if (this.isPageTransmission) {
        if (this.critereRecherche.factorDateTransmission.dateFin
          && this.critereRecherche.factorDateTransmission.dateDebut
          > this.critereRecherche.factorDateTransmission.dateFin) {
          this.errors.push({
            message: 'transmission.filtre.error.errorfactorDateTransmission',
          });
        }
        this.critereRecherche.tiersFactorIds = this.tiersFactorsSelected;
      }
      if (this.moduleSecteurActive) {
        this.critereRecherche.secteurIds = this.secteursSelected.map(s => s.id);
      }
      this.setCritere(this.critereRecherche);
      this.$emit('recherche');
    },
    getModeReglementTag() {
      this.modeReglementTags = this.listeModeReglementBase.filter((modeReglement) => {
        return !this.modeReglementSelected.map(a => a.id).includes(modeReglement.id);
      });
    },
    getFilteredModeReglementTags(text) {
      this.getModeReglementTag();
      this.modeReglementTags = this.modeReglementTags.filter((modeReglement) => {
        return modeReglement.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getRegleFacturationTag() {
      this.regleFacturationTags = this.reglesFacturation.filter((regleFacturation) => {
        return !this.regleFacturationSelected.map(r => r.id).includes(regleFacturation.id);
      });
    },
    getFilteredRegleFacturationTags(text) {
      this.getRegleFacturationTag();
      this.regleFacturationTags = this.regleFacturationTags.filter((regleFacturation) => {
        return regleFacturation.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    async initializeFiltre() {
      this.critereRecherche = cloneDeep(this.$store.getters[`${this.storeName}/criteresRecherche`]);
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        await this.loadParametres([PARAMETRES_KEYS.modeReglement,
          PARAMETRES_KEYS.regleFacturation, PARAMETRES_KEYS.secteur]);
        const users = this.parametre(PARAMETRES_KEYS.utilisateur).filter(u => u.actif);
        await updateCritereWithParametreInterne(this.critereRecherche);
        this.listeAssistant = initialUsers(users, [ASSISTANT_COMMERCIAL], this.$i18n.t('listeFactures.filtre.noAssistant'));
        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL], this.$i18n.t('listeFactures.filtre.noCommercial'));

        if (this.critereRecherche.tiersId.length > 0
          && this.storeName !== FACTURE_CLIENT_STORE_NAME) {
          this.tiers = (await getTiers(this.critereRecherche.tiersId[0])).data.result;
        }
        if (this.critereRecherche.commandeId) {
          this.commandes = [(await get(this.critereRecherche.commandeId)).data.result];
        }
        if (this.critereRecherche.referenceIds.length > 0) {
          const promiseCommande = [];
          this.critereRecherche.referenceIds.forEach((commandeId) => {
            promiseCommande.push(get(commandeId));
          });
          this.commandes = (await Promise.all(promiseCommande)).map((rslt => rslt.data.result));
        }
        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.critereRecherche.commercialId.includes(c.id);
        });
        this.assistantSelected = this.listeAssistant.filter((a) => {
          return this.critereRecherche.assistantIds.includes(a.id);
        });
        this.listeModeReglementBase = this.modesReglement;
        if (this.critereRecherche.modesReglementsIds.length > 0) {
          this.modeReglementSelected = this.listeModeReglementBase.filter((modeReglemnt) => {
            return this.critereRecherche.modesReglementsIds.includes(modeReglemnt.id);
          });
        }
        this.getModeReglementTag();
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
          PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
          PARAMETRES_INTERNE_KEYS.modulePresse.key,
          PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
          PARAMETRES_INTERNE_KEYS.modulePlanMedia.key]);
        this.enseigneSelected = this.critereRecherche.enseigneIds;
        this.groupeSelected = this.critereRecherche.groupeIds;
        this.clientsSelected = this.critereRecherche.clients;
        this.tiersFactorsSelected = this.critereRecherche.tiersFactorIds;
        this.produitsSelected = this.critereRecherche.produitsIds;
        this.commandeSelected = this.critereRecherche.commandeIds;
        if (this.modulePresseActive) {
          this.getRegleFacturationTag();
          this.parutionsSelected = this.critereRecherche.parutionsIds;
          this.regleFacturationSelected = this.critereRecherche.regleFacturationIds;
        }
        if (this.modulePlanMediaActive) {
          this.planMediaSelected = this.critereRecherche.planMediaIds;
        }
        if (this.moduleSecteurActive) {
          this.secteurCurrentUser = await getSecteursIdByUser(this.constantes.COMMERCIAL, true);
          if (this.critereRecherche.secteurIds.length > 0) {
            this.secteursSelected = this.secteurs.filter((s) => {
              return this.critereRecherche.secteurIds.includes(s.id) && s.actif === true;
            });
          }
          if (this.secteurCurrentUser?.length > 0) {
            this.secteursSelected = this.secteurCurrentUser;
            this.critereRecherche.secteurIds = this.secteursSelected.map(s => s.id);
          }
        }
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
